import React from 'react';
import { useTranslation } from 'react-i18next';
import unnamedLightLogo from '../../../assets/images/unnamed-light-logo.png';
import './CorePhilosophySection.scss';

const PILLARS = [
  {
    titleKey: 'home.philosophy.pillar1Title',
    descKey: 'home.philosophy.pillar1Desc',
    gradient: 'linear-gradient(135deg, rgb(154, 167, 143) 0%, rgba(154, 167, 143, 0.4) 100%)',
  },
  {
    titleKey: 'home.philosophy.pillar2Title',
    descKey: 'home.philosophy.pillar2Desc',
    gradient: 'linear-gradient(135deg, rgb(221, 184, 146) 0%, rgba(221, 184, 146, 0.4) 100%)',
  },
  {
    titleKey: 'home.philosophy.pillar3Title',
    descKey: 'home.philosophy.pillar3Desc',
    gradient: 'linear-gradient(135deg, rgb(155, 177, 184) 0%, rgba(155, 177, 184, 0.4) 100%)',
  },
];

function CorePhilosophySection() {
  const { t, i18n } = useTranslation();
  const isEn = !i18n.language?.startsWith('zh');

  return (
    <section
      id="philosophy"
      className={`core-philosophy ${isEn ? 'core-philosophy--en' : ''}`}
    >
      <div className="core-philosophy__header">
        <img
          src={unnamedLightLogo}
          alt=""
          className="core-philosophy__icon"
        />
        <h2 className="core-philosophy__title">
          {t('home.philosophy.title')}
        </h2>
        <p className="core-philosophy__subtitle">
          {t('home.philosophy.subtitle')}
        </p>
      </div>

      <div className="core-philosophy__pillars">
        {PILLARS.map((pillar) => (
          <div key={pillar.titleKey} className="core-philosophy__pillar">
            <div
              className="core-philosophy__pillar-ring"
              style={{ backgroundImage: pillar.gradient }}
            >
              <div className="core-philosophy__pillar-center" />
            </div>
            <h3 className="core-philosophy__pillar-title">
              {t(pillar.titleKey)}
            </h3>
            <p className="core-philosophy__pillar-desc">
              {t(pillar.descKey)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default CorePhilosophySection;
